export default function Navbar() {
  return (
    <div className="navbar bg-base-100 font-lato sticky top-0 z-50">
      <div className="navbar-start">
        <div className="dropdown">
          <div tabIndex={0} role="button" className="btn btn-ghost lg:hidden">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h8m-8 6h16"
              />
            </svg>
          </div>
          <ul
            tabIndex={0}
            className="menu menu-sm dropdown-content bg-base-100 rounded-box z-[1] mt-3 w-52 p-2 shadow"
          >
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <a href="/about-us">About Us</a>
            </li>
            <li>
              <a href="/plans">Our Plans</a>
            </li>
          </ul>
        </div>
        <a className="btn btn-ghost text-xl" href="/">
          <span className="text-secondary-500">PROBI</span>
          <span className="text-primary-900 ml-[-5]">MINING</span>
        </a>
      </div>
      <div className="navbar-center hidden lg:flex">
        <ul className="menu menu-horizontal px-1 text-secondary-500">
          <li>
            <a href="/">Home</a>
          </li>
          <li>
            <a href="/about-us">About Us</a>
          </li>
          <li>
            <a href="/plans">Our Plans</a>
          </li>
        </ul>
      </div>
      <div className="navbar-end">
        <a className="btn bg-secondary-500" href="/login">
          Login
        </a>
      </div>
    </div>
  );
}
